import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AuthLayout from '../_layouts/auth';
import { Input, Button, Link as LinkMD } from 'mondrian-react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import { useLoader } from '../../hooks/loader';
import { Auth } from 'aws-amplify';
import ModalForgotPassword from './components/ModalForgotPassword';
import styles from './styles.module.css';
import ModalChangePassword from '../_layouts/default/components/ModalChangePassword';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [token, setToken] = useState('');
  const [inputError, setInputError] = useState(false);
  const [inputErrorMessage, setInputErrorMessage] = useState('');
  const [recaptchaError, setRecaptchaError] = useState(false);
  const [openModalPassword, setOpenModalPassword] = useState(false);

  const [showModalNewPassword, setModalNewPassword] = useState(true);
  const [newPassword, setNewPassword] = useState(atob('VGVzdGVAMTIz'));

  const reCaptcha = useRef();
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const { setLoading } = useLoader();
  const siteKey = `6Lfx36EaAAAAAD_7-XU4dPVit1PffrKvunEz1FAm`;

  const handleToken = (token) => {
    if (token) {
      setRecaptchaError(false);
      return setToken(token);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    setLoading(true);
    setInputError(false);

    if (token === '') {
      addToast({
        type: 'error',
        title: 'Erro de validação!',
        description: 'Por favor, verifique o catcha.',
      });
      setLoading(false);
      return setRecaptchaError(true);
    }

    Auth.signIn({
      username: email,
      password,
    })
      .then((cognitoUser) => {
        if (cognitoUser.challengeName === 'NEW_PASSWORD_REQUIRED') {
          if(newPassword) {
            const { requiredAttributes } = cognitoUser.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']
            Auth.completeNewPassword(
                cognitoUser,       // the Cognito cognitoUser Object
                newPassword,       // the new password
                {
                  name: email
                }
            ).then(cognitoUser => {
                // at this time the cognitoUser is logged in if no MFA required
                Auth.currentSession()
                  .then((userSession) => {
                    signIn(email, userSession.getIdToken().getJwtToken());
                    setLoading(false);
                  }).catch(err => {
                    console.log(err);
                  })
            }).catch(err => {
              console.log(err);
            });
          }
      } else {
          Auth.currentSession()
          .then((userSession) => {
            signIn(email, userSession.getIdToken().getJwtToken());
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
          });
        }        
      })
      .catch((err) => {
        console.log(err);
        if(err.code === ""){

        }
        addToast({
          type: 'error',
          title: 'E-mail ou senha incorreto!',
          description: 'Verifique os dados e tente novamente.',
        });
        setLoading(false);
        setInputError(true);
        setInputErrorMessage('E-mail ou senha incorreto.');
      });
  };

  useEffect(() => {
    return () => {
      setEmail('');
      setPassword('');
      setToken('');
      setLoading(false);
      setInputError(false);
      setInputErrorMessage('');
      setRecaptchaError(false);
    };
  }, [setLoading]);

  return (
    <AuthLayout>
      <form onSubmit={handleSubmit}>
        <div className={styles.FormInput}>
          <Input
            required
            email
            id="email"
            name="email"
            onChange={(e) => setEmail(e.target.value)}
            hasError={inputError ? true : false}
            errorMessage={inputErrorMessage ? inputErrorMessage : ''}
            parentClassName={
              inputError
                ? 'mdn-Input--activatedField mdn-Input--attentionField'
                : 'mdn-Input--activatedField'
            }
          >
            E-mail
          </Input>
        </div>
        <div className={styles.FormInput}>
          <Input
            required
            password
            id="password"
            name="password"
            onChange={(e) => setPassword(e.target.value)}
            hasError={inputError ? true : false}
            errorMessage={inputErrorMessage ? inputErrorMessage : ''}
            parentClassName={
              inputError
                ? 'mdn-Input--activatedField mdn-Input--attentionField'
                : 'mdn-Input--activatedField'
            }
          >
            Senha
          </Input>
        </div>
        <div
          className={recaptchaError ? styles.RecaptchaError : styles.Recaptcha}
        >
          <br />
          <ReCAPTCHA
            ref={reCaptcha}
            sitekey={siteKey}
            onChange={(token) => handleToken(token)}
            onExpired={() => setToken('')}
          />
          {recaptchaError && (
            <small className={styles.RecaptchaErrorFeedback}>
              Por favor, verifique o captcha para prosseguir.
            </small>
          )}
        </div>

        <Button block submit="true" className={styles.FormButtonSubmit}>
          Entrar
        </Button>
        {/* <Link to="/register" className={styles.Link}>
          <Button block secondary>
            Cadastrar
          </Button>
        </Link> */}

        <LinkMD
          className={styles.LinkForgotPassword}
          onClick={() => setOpenModalPassword(true)}
        >
          Esqueci minha senha
        </LinkMD>
      </form>

      <ModalForgotPassword
        open={openModalPassword}
        close={() => setOpenModalPassword(false)}
      />

      {/* <ModalChangePassword
        title={''}
        open={showModalNewPassword}
        close={() => setModalNewPassword(false)}
      /> */}

    </AuthLayout>
  );
}

export default Login;
